import FormInputTypes from '../../../components/atoms/formEnums/formInputTypes';
// import tableVodCatalog from './tableVodTemplateCatalog';
import IngestServersFields from './formGroup20ServersFields';

export default {
  title: 'Ingest Servers',
  attributeName: 'liveIngestServers',
  fields: [
    {
      attributeName: 'ingestServers',
      type: FormInputTypes.JSON_COMPONENT,
      emptyMessage: "You don't have any ingest server, click on the +new button to make a new one.",
      columns:1,
      label: 'Ingest Servers',
      itemLabel:'Ingest server',
      required: true,
      helpText: 'Insert new ingest servers clicking in + button.',
      returnedPopupValues:{"masterIngestName1":"name"},
      extraValues:['deploymentType','deploymentGPU'],
      errorText: '',
      popupFormGroups:[
        IngestServersFields
      ]
    },
  ]
};
